/** Flag variable that lets the dashboard stop an experiment's Tealium decision event. */
export const SEND_TO_TEALIUM_VARIABLE = 'send_to_tealium';

/** Only an explicit false opts out, so a flag without the variable keeps sending. */
export const shouldSendToTealium = (variables?: Record<string, unknown> | null): boolean =>
	variables?.[SEND_TO_TEALIUM_VARIABLE] !== false;
